module.exports = __webpack_public_path__ + "static/media/successful-partnerships-bg.c8ac8787.avif";